__turbopack_context__.v({
  "badge": "TaxBadge-module-scss-module__SDTDQa__badge",
});
